import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Visibility } from "@mui/icons-material";

export const FranchisesList = ({
  franchises,
  franchisesReport,
  onFranchiseClick
}) => {
  return (
    <Paper>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nome da Unidade</TableCell>
              <TableCell align="center">Membros</TableCell>
              <TableCell align="center">Posts</TableCell>
              <TableCell>Criado em</TableCell>
              <TableCell>Atualizado em</TableCell>
              <TableCell align="center">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {franchises.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} sx={{ textAlign: "center", py: 4 }}>
                  Nenhuma unidade encontrada
                </TableCell>
              </TableRow>
            ) : (
              franchises.map((franchise) => {
                // Find additional data from report
                const reportData = franchisesReport?.franchises?.find(
                  f => f.id === franchise.id
                );

                return (
                  <TableRow
                    key={franchise.id}
                    hover
                    sx={{
                      "&:hover": {
                        bgcolor: "var(--grey-50-color)",
                        cursor: "pointer"
                      }
                    }}
                    onClick={() => onFranchiseClick(franchise)}
                  >
                    <TableCell>
                      <Typography variant="body1" sx={{ fontWeight: 500 }}>
                        {franchise.name}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="body2">
                        {reportData?.creatorsCount || 0}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography variant="body2">
                        {reportData?.postsCount || 0}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {franchise.created_at ?
                        new Date(franchise.created_at).toLocaleDateString('pt-BR') :
                        '-'
                      }
                    </TableCell>
                    <TableCell>
                      {franchise.updated_at ?
                        new Date(franchise.updated_at).toLocaleDateString('pt-BR') :
                        '-'
                      }
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="Ver detalhes da unidade">
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            onFranchiseClick(franchise);
                          }}
                          sx={{ color: "var(--primary-color)" }}
                        >
                          <Visibility />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
